var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 60,
    viewBox: "0 0 57 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3792 0L54.4664 26.0871C57.5225 29.1433 57.5225 34.0983 54.4664 37.1544L33.9129 57.7079C30.8567 60.764 25.9017 60.764 22.8456 57.7079L2.2921 37.1544C-0.764037 34.0983 -0.764034 29.1433 2.29211 26.0871L28.3792 0Z",
    fill: "#30B3D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3256 28.1541C24.3727 28.1073 24.41 28.0516 24.4354 27.9903C24.4609 27.929 24.474 27.8634 24.474 27.797C24.474 27.7307 24.4609 27.665 24.4354 27.6037C24.41 27.5425 24.3727 27.4868 24.3256 27.4399L17.9524 21.0842L11.5791 27.4394C11.4843 27.5342 11.4311 27.6625 11.4311 27.7963C11.4311 27.9302 11.4843 28.0585 11.5791 28.1533L13.4132 29.9822L17.9524 25.4563L22.4916 29.9835L24.3256 28.1541Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1943 28.1541C45.2413 28.1073 45.2786 28.0516 45.3041 27.9903C45.3295 27.929 45.3427 27.8634 45.3427 27.797C45.3427 27.7307 45.3295 27.665 45.3041 27.6037C45.2786 27.5425 45.2413 27.4868 45.1943 27.4399L38.821 21.0842L32.4477 27.4394C32.353 27.5342 32.2998 27.6625 32.2998 27.7963C32.2998 27.9302 32.353 28.0585 32.4477 28.1533L34.2818 29.9822L38.821 25.4563L43.3602 29.9835L45.1943 28.1541Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.ec8a4245deafbe7995f337c0fe7dca80.svg";
export { ForwardRef as ReactComponent };